function toNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function firstQuote(primary, fallback) {
  if (primary !== undefined && primary !== null && primary !== '') {
    return toNumber(primary);
  }
  return toNumber(fallback);
}

function pricesMatch(a, b) {
  return Math.abs(a - b) < 0.02;
}

function isCircuitLock(bid, ask, ltp, lower, upper) {
  if (!(ltp > 0)) return false;

  const atLower = lower > 0 && ltp <= lower + 0.01;
  const atUpper = upper > 0 && ltp >= upper - 0.01;
  if ((bid <= 0 || ask <= 0) && (atLower || atUpper)) return true;

  // One side of the book is empty and the live side is the last trade.
  if (bid <= 0 && ask > 0 && pricesMatch(ask, ltp)) return true;
  if (ask <= 0 && bid > 0 && pricesMatch(bid, ltp)) return true;

  return false;
}

/**
 * Mark price for an open position.
 * Buy positions use bid; sell positions use ask.
 * On a lower or upper circuit the missing side is 0, so LTP is used instead.
 */
export function circuitMarkPrice(stock = {}, position = {}, side) {
  const bid = firstQuote(stock.Bid, position.buyPrice);
  const ask = firstQuote(stock.Ask, position.sellPrice);
  const ltp = firstQuote(
    stock.LTP,
    stock.lastTradedPrice ?? position.lastTradedPrice
  );
  const quote = side === 'buy' ? bid : ask;

  if (quote > 0) return quote;
  if (!(ltp > 0)) return 0;

  const lower = toNumber(
    position.lowerCircuit ?? position.lower_circuit ?? stock.lower_circuit ?? stock.lowerCircuit
  );
  const upper = toNumber(
    position.upperCircuit ?? position.upper_circuit ?? stock.upper_circuit ?? stock.upperCircuit
  );

  if (isCircuitLock(bid, ask, ltp, lower, upper)) return ltp;
  return 0;
}
